import { CustomCollapseCard, Text } from '@src/components';
import { useSelector } from 'react-redux';
import { moneyFormat } from '@src/utils/utils';
import dayjs from '@src/utils/day';
import { defaultDateFormat } from '@src/utils/keys';
import { monthsList } from '@src/store/enums';

const OrderSummaryInformation = () => {
  const { currentCardOrder } = useSelector((state) => state?.cardOrder);

  const invoiceMonthText = monthsList
    .filter((month) => month.value === currentCardOrder?.invoiceMonth)
    .reduce((acc, month) => month.text, '');

  const cardParemetersText = () => {
    return (
      <>
        <div className="title">
          <b>
            <Text t="cardPrintingOptions" />
          </b>
        </div>
        <div className="summary-list">
          <span>{currentCardOrder?.printNameSurname ? <Text t="printWithName" /> : <Text t="printWithoutName" />}</span>
          <span>
            {currentCardOrder?.printCompanyName ? <Text t="printWithCompanyName" /> : <Text t="printWithoutCompanyName" />}
          </span>
          <span>
            {currentCardOrder?.printCompanyLogo
              ? <Text t="printWithCompanyLogo" />
              : <Text t="printWithoutCompanyLogo" />}
          </span>
        </div>
      </>
    );
  };

  return (
    <>
      <CustomCollapseCard
        cardTitle={<Text t="orderSummaryTitle" />}
        cardTitleAlign="center"
        className="card-order-summary-collapse"
      >
        <div className="card-summary-container">
          <div className="order-summary-col-1">
            <div className="title">
              <b><Text t="cardType2" />:</b>
              <span> {currentCardOrder?.cardType === 0 ? <Text t="physical" /> : <Text t="digital" />}</span>
            </div>
            {currentCardOrder?.cardType === 0 && cardParemetersText()}
          </div>

          {currentCardOrder?.totalPrice > 0 && (
            <div className="order-summary-col-2">
              <div className="title">
                <b><Text t="autoActivationDate" />:</b>
                <span>{dayjs(currentCardOrder?.cardActivationDate).format(defaultDateFormat)}</span>
              </div>
              <div className="title">
                <b>
                  <Text t="invoiceAddress" />
                </b>{' '}
                <span>{currentCardOrder?.invoiceAddress}</span>
              </div>
              <div className="title">
                <b>
                  <Text t="invoiceMonth2" />
                </b>{' '}
                <span>{invoiceMonthText}</span>
              </div>
              <div className="title e-invoice-information">
                <b>
                  <Text t="eInvoiceAdditionalInformation2" />
                </b>
                <span>{currentCardOrder?.eInvoiceInformation}</span>
              </div>
            </div>
          )}

          <div className="order-summary-col-3">
            <div className="custom-info-box">
              <div className="title">
                <b><Text t="numberOfCards3" />:</b>
              </div>
              <span>{currentCardOrder?.totalCount}</span>
            </div>
            <div className="custom-info-box">
              <div className="title">
                <b><Text t="totalBalanceLoad" />:</b>
              </div>
              <span>{moneyFormat(currentCardOrder?.totalPrice, true)}</span>
            </div>
            <div className="custom-info-box">
              <div className="title">
                <b><Text t="totalAmountToBePaid" />:</b>
              </div>
              <span>{moneyFormat(currentCardOrder?.totalPaymentAmount, true)}</span>
            </div>
          </div>
        </div>
      </CustomCollapseCard>
    </>
  );
};

export default OrderSummaryInformation;
